var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Label, SpinnerIcon, Tooltip, TooltipTrigger, translate, useTooltip, } from '@lucidlink/uicore';
import { FileBrowserTestIdFactory } from '../interactions';
export const RemoteUploadInProgress = ({ entryId, }) => {
    _react_refresh_temp_2();
    const { isTooltipActive, tooltipProps, triggerProps } = useTooltip({
        placement: 'right',
    });
    return (_jsxs(TooltipTrigger, { triggerProps: triggerProps, children: [_jsx(Label, { color: "static_info", "data-testid": FileBrowserTestIdFactory.getEntryInProgressTestId(entryId), StartIcon: SpinnerIcon, text: translate('In progress') }), isTooltipActive && (_jsx(Tooltip, { contents: [
                    translate('Another user is still uploading file changes to the cloud.'),
                ], tooltipProps: tooltipProps }))] }));
};
_react_refresh_temp_1 = RemoteUploadInProgress;
$RefreshReg$(_react_refresh_temp_1, "RemoteUploadInProgress");
_react_refresh_temp_2(RemoteUploadInProgress, "6Z9hKiQbkXe/L4MlJ1mOoLfPqrI=", false, () => [useTooltip]);
